import { Column } from 'react-table';
import { TextColumn } from 'shared/tables/columns';
import { NameChangeReviewGridItem } from 'shared/types';
import { NameChangeButtons } from './name-change-buttons';

export const customerNameChangeTableColumns: Column<NameChangeReviewGridItem>[] = [
  {
    Header: 'New Proposed Name',
    accessor: 'newCustomerName',
    Cell: TextColumn,
    align: 'center',
  },
  {
    Header: 'Current Customer Name',
    accessor: 'currentCustomerName',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Channel',
    accessor: 'channel',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Tier',
    accessor: 'customerTier',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Created By',
    accessor: 'modifiedBy',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Creation Date',
    accessor: 'modifiedDate',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Approver',
    accessor: 'approvedBy',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Approval Date',
    accessor: 'approvedDate',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Status',
    accessor: 'approvalStatus',
    Cell: TextColumn,
    align: 'center',
  },
  {
    Header: 'Actions',
    Cell: NameChangeButtons,
    align: 'center',
  },
];
